import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Horse } from '../../../models/horse';
import { faPlus }  from '@fortawesome/fontawesome-pro-regular';
import { faHorse } from '@fortawesome/pro-solid-svg-icons'
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-modal-choose-horse',
  templateUrl: './modal-choose-horse.component.html',
styleUrls:  ['./modal-choose-horse.component.css']
})
export class ModalChooseHorseComponent extends SmsAbstractAppPage implements OnInit {

  faPlus = faPlus;
  faHorse = faHorse;

  @Output() horse_selected$: EventEmitter<Horse> = new EventEmitter<Horse>();
  @Output() add_new_selected$: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(public activeModal: NgbActiveModal) {
    super();
  }

  ngOnInit() {
  }

  handleHorseSelection(horse: Horse){
  	this.horse_selected$.emit(horse);
  }

  handleAddNew(){
  	this.add_new_selected$.emit(true);
  }

}
